import { loadApp } from "../actions";

export const mapDispatchToProps = dispatch => ({
  loadApp: id =>
    /** *
     * TODO: instead of passing in global dispatch function
     * as an arg, actions.loadApp should use mapDispatchToProps
     */
    loadApp(dispatch, id),
});
